var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingQiwaAcademic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0607 1.74785C9.80912 1.64004 9.52438 1.64004 9.27283 1.74785L2.27283 4.74785C1.90514 4.90543 1.66675 5.26696 1.66675 5.66699C1.66675 6.06702 1.90514 6.42856 2.27283 6.58614L4.91712 7.71941C5.01328 7.61046 5.13381 7.52172 5.27283 7.46215L9.27283 5.74786C9.78046 5.5303 10.3683 5.76546 10.5859 6.27309C10.8034 6.78071 10.5683 7.36859 10.0607 7.58615L7.33343 8.75497L9.27283 9.58614C9.52438 9.69394 9.80912 9.69394 10.0607 9.58614L17.0607 6.58614C17.4284 6.42856 17.6667 6.06702 17.6667 5.66699C17.6667 5.26696 17.4284 4.90543 17.0607 4.74785L10.0607 1.74785Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97679 9.06372L4.66675 9.78799V13.8896C4.32398 13.8119 3.9738 13.7537 3.61746 13.7164C3.14769 13.6671 2.77644 13.2959 2.72719 12.8261C2.68721 12.4448 2.66675 12.058 2.66675 11.6668C2.66675 10.7703 2.77416 9.89848 2.97679 9.06372Z",
    fill: "#23242A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9667 16.2395C8.29383 15.5799 7.51842 15.0254 6.66675 14.6021V10.6451L8.48499 11.4244C9.23963 11.7478 10.0939 11.7478 10.8485 11.4244L16.3567 9.06372C16.5593 9.89848 16.6667 10.7703 16.6667 11.6668C16.6667 12.058 16.6463 12.4448 16.6063 12.8261C16.5571 13.2959 16.1858 13.6671 15.716 13.7164C13.6432 13.9337 11.7791 14.855 10.3668 16.2395C9.97794 16.6207 9.35556 16.6207 8.9667 16.2395Z",
    fill: "#23242A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 17.667C6.21903 17.667 6.66675 17.2192 6.66675 16.667V14.6021C6.03811 14.2897 5.36792 14.0487 4.66675 13.8896V16.667C4.66675 17.2192 5.11446 17.667 5.66675 17.667Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingQiwaAcademic);
export default __webpack_public_path__ + "static/media/onboarding-qiwa-academic.39382c15ed7559d0f5b43e0be1ee49c6.svg";
export { ForwardRef as ReactComponent };